import {StandardPageSize} from "@react-pdf/types";
import {Orientation} from "@react-pdf/types/page";

import {LABELS_CONFIG} from "../Config/labels";
import {FormPaperColorEnum, FormPrintColorEnum, LabelConfigType, Price} from "../Types";

export const isEan = (ean: string) => {
  return ean.length === 8 || ean.length === 13 || ean.length === 128;
}
export const importAll = (r: any)=> {
  return r.keys().map(r);
}

export const getLabelTypes = () => {
  return LABELS_CONFIG.map(labelConfig => labelConfig.name);
}

export const getLabelPreview = (labelTypeName: string) => {
  return LABELS_CONFIG.find(labelConfig => labelConfig.name === labelTypeName)?.preview;
}

export const getLabelConfig = (name: string | null) => {
  return LABELS_CONFIG.find(labelConfig => labelConfig.name === name);
}

export const isPrintOptionOrientationAvailable = (
  size: StandardPageSize,
  orientation: Orientation,
  config: LabelConfigType,
) => {
  return config.printOptions.orientations[orientation].includes(size);
}

export const getDefaultOrientation = (
  size: StandardPageSize,
  config: LabelConfigType,
) => {
  return (Object.keys(config.printOptions.orientations) as Orientation[]).find(
    (orientation) => config.printOptions.orientations[orientation].includes(size),
  );
}

export const isPrintOptionPrintColorAvailable = (
  config: LabelConfigType,
) => {
  return config.printOptions.printColors.includes(FormPrintColorEnum.BW)
    && config.printOptions.printColors.includes(FormPrintColorEnum.COLOR);
}

export const isPrintOptionPaperColorAvailable = (
  paperColor: FormPaperColorEnum,
  config: LabelConfigType,
) => {
  return config.printOptions.paperColors.includes(paperColor);
}

export const getPriceFromNumber = (number: number | null): Price => {
  if (number === null) {
    return {
      whole: '',
      decimals: '',
    }
  }

  const numberString = number.toFixed(2);
  const price = parseFloat(numberString.replace(',', '.'));
  const whole = Math.trunc(price);

  const decimals = Math.abs((price - whole)).toFixed(2).split('.')[1];

  return {
    whole: whole.toString(),
    decimals: decimals.toString(),
  }
}
